// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-header {
  background: linear-gradient(135deg, #1ab394, #13806a);
  color: white;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 50px;
  flex-shrink: 0;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  z-index: 20;
}
.chat-header .resize-handle {
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  cursor: nwse-resize;
  z-index: 25;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.15);
  border-radius: 0 0 4px 0;
}
.chat-header .resize-handle i {
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
}
.chat-header .resize-handle:hover {
  background-color: rgba(255, 255, 255, 0.3);
}
.chat-header .chat-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 16px;
  flex-shrink: 0;
}
.chat-header .chat-title i {
  font-size: 18px;
  flex-shrink: 0;
}
.chat-header .chat-title span {
  white-space: nowrap;
}
.chat-header .chat-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.chat-header .chat-actions .action-btn {
  background: transparent;
  border: none;
  color: white;
  padding: 6px 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-size: 14px;
  min-width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.chat-header .chat-actions .action-btn i {
  font-size: 14px;
  line-height: 1;
}
.chat-header .chat-actions .action-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}
.chat-header .chat-actions .action-btn.close-btn:hover {
  background: rgba(255, 71, 87, 0.8);
}

@media (max-width: 600px) {
  .chat-header {
    padding: 12px 16px;
  }
  .chat-header .chat-title {
    font-size: 14px;
  }
  .chat-header .chat-title i {
    font-size: 16px;
  }
  .chat-header .chat-title span {
    display: none;
  }
  .chat-header .chat-actions {
    gap: 4px;
  }
  .chat-header .chat-actions .action-btn {
    min-width: 28px;
    height: 28px;
    padding: 4px;
  }
  .chat-header .chat-actions .action-btn i {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/angularApp/components/wings-assistant-chat/wings-chat-header.scss"],"names":[],"mappings":"AACA;EACE,qDAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;AAAF;AACE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2CAAA;EACA,wBAAA;AACJ;AACI;EACE,+BAAA;EACA,eAAA;AACN;AAEI;EACE,0CAAA;AAAN;AAIE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAFJ;AAII;EACE,eAAA;EACA,cAAA;AAFN;AAKI;EACE,mBAAA;AAHN;AAOE;EACE,aAAA;EACA,QAAA;EACA,cAAA;AALJ;AAOI;EACE,uBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,sCAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AALN;AAOM;EACE,eAAA;EACA,cAAA;AALR;AAQM;EACE,oCAAA;AANR;AASM;EACE,kCAAA;AAPR;;AAcA;EACE;IACE,kBAAA;EAXF;EAaE;IACE,eAAA;EAXJ;EAaI;IACE,eAAA;EAXN;EAcI;IACE,aAAA;EAZN;EAgBE;IACE,QAAA;EAdJ;EAgBI;IACE,eAAA;IACA,YAAA;IACA,YAAA;EAdN;EAgBM;IACE,eAAA;EAdR;AACF","sourcesContent":["// Wings Chat Header Component Styles\n.chat-header {\n  background: linear-gradient(135deg, #1ab394, #13806a);\n  color: white;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 50px;\n  flex-shrink: 0;\n  width: 100%;\n  box-sizing: border-box;\n  position: relative;\n  z-index: 20;  // Resize handle no canto superior esquerdo - sem transição para resposta mais rápida\n  .resize-handle {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 20px;\n    height: 20px;\n    cursor: nwse-resize;\n    z-index: 25;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(255, 255, 255, 0.15);\n    border-radius: 0 0 4px 0;\n    \n    i {\n      color: rgba(255, 255, 255, 0.8);\n      font-size: 12px;\n    }\n    \n    &:hover {\n      background-color: rgba(255, 255, 255, 0.3);\n    }\n  }\n\n  .chat-title {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-weight: 600;\n    font-size: 16px;\n    flex-shrink: 0;\n\n    i {\n      font-size: 18px;\n      flex-shrink: 0;\n    }\n\n    span {\n      white-space: nowrap;\n    }\n  }\n\n  .chat-actions {\n    display: flex;\n    gap: 8px;\n    flex-shrink: 0;\n\n    .action-btn {\n      background: transparent;\n      border: none;\n      color: white;\n      padding: 6px 8px;\n      border-radius: 6px;\n      cursor: pointer;\n      transition: background-color 0.2s ease;\n      font-size: 14px;\n      min-width: 32px;\n      height: 32px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-shrink: 0;\n\n      i {\n        font-size: 14px;\n        line-height: 1;\n      }\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.2);\n      }\n\n      &.close-btn:hover {\n        background: rgba(255, 71, 87, 0.8);\n      }\n    }\n  }\n}\n\n// Responsive adjustments\n@media (max-width: 600px) {\n  .chat-header {\n    padding: 12px 16px;\n\n    .chat-title {\n      font-size: 14px;\n\n      i {\n        font-size: 16px;\n      }\n\n      span {\n        display: none; // Hide text on very small screens\n      }\n    }\n\n    .chat-actions {\n      gap: 4px;\n\n      .action-btn {\n        min-width: 28px;\n        height: 28px;\n        padding: 4px;\n\n        i {\n          font-size: 12px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
